module.exports = __webpack_public_path__ + "static/media/weLink-browser.1a76e764.svg";